import { Pipe, PipeTransform } from '@angular/core';
import { BaseViewComponent } from '../views/base-view.component';

@Pipe({name: 'contentOrDash', standalone: true})

// This is a pipe that shows the content or will display - for mobile. If you need a - for desktop as well, use the pipe like this contentOrDash: true.
export class ContentOrDashPipe<T> extends BaseViewComponent implements PipeTransform {
    transform(content: T | null, dashForDesktop: boolean = false) {

        if (content !== null && content !== undefined && (typeof content === 'string' &&  content.length > 0)) {
            return content;
        } else {
            if (this.isMobileOrTablet || dashForDesktop) {
                return '-';
            } else {
                return '';
            }
        }
    }
}